import { Icon } from "@iconify/react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCardsData } from "../../redux/features/batchSlice";
import { useSelector } from "react-redux";

const CardsData = ({}) => {
  const dispatch = useDispatch();

  const { loading, cardData } = useSelector((state) => state.batch);

  useEffect(() => {
    dispatch(getCardsData());
  }, []);

  return (
    <>
      <Box sx={{ width: "100%", padding: 0, mb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} sm={3}>
            <Box
              sx={{
                width: "100%",
                background: "linear-gradient(to right, #A125C2,#0068C2)",
                borderRadius: "15px",
                padding: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Stack direction={"row"} spacing={1}>
                <Icon
                  icon={"jam:task-list-f"}
                  width={25}
                  height={25}
                  color="#fff"
                />
                <Typography variant="body1" color={"#fff"}>
                  Total Batches
                </Typography>
              </Stack>
              <Typography variant="h3" color={"#fff"}>
                {cardData?.TotalBatches}
              </Typography>
              <Typography variant="body1" color={"#fff"}>
                All Time Created Batches
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3} sm={3}>
            <Box
              sx={{
                width: "100%",
                background: "linear-gradient(to right, #A125C2,#0068C2)",
                borderRadius: "15px",
                padding: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Stack direction={"row"} spacing={1}>
                <Icon
                  icon={"nrk:bell-active"}
                  width={25}
                  height={25}
                  color="#fff"
                />
                <Typography variant="body1" color={"#fff"}>
                  Active Batches
                </Typography>
              </Stack>
              <Typography variant="h3" color={"#fff"}>
                {cardData?.Active}
              </Typography>
              <Typography variant="body1" color={"#fff"}>
                Currently Ongoing
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3} sm={3}>
            <Box
              sx={{
                width: "100%",
                background: "linear-gradient(to right, #A125C2,#0068C2)",
                borderRadius: "15px",
                padding: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Stack direction={"row"} spacing={1}>
                <Icon icon={"ion:time"} width={25} height={25} color="#fff" />
                <Typography variant="body1" color={"#fff"}>
                  Upcoming Batches
                </Typography>
              </Stack>
              <Typography variant="h3" color={"#fff"}>
                {cardData?.Upcoming}
              </Typography>
              <Typography variant="body1" color={"#fff"}>
                Starting Within 30 Days
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3} sm={3}>
            <Box
              sx={{
                width: "100%",
                background: "linear-gradient(to right, #A125C2,#0068C2)",
                borderRadius: "15px",
                padding: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Stack direction={"row"} spacing={1}>
                <Icon
                  icon={"ion:person-sharp"}
                  width={25}
                  height={25}
                  color="#fff"
                />
                <Typography variant="body1" color={"#fff"}>
                  Avg Capacity Use
                </Typography>
              </Stack>
              <Typography variant="h3" color={"#fff"}>
                {loading ? 0 : `${Math.round(cardData?.AverageCapacity * 100) / 100}`}%
              </Typography>
              <Typography variant="body1" color={"#fff"}>
                Across All Active Batches
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CardsData;
